
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

export default function BottomNavigation() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { path: '/', icon: 'ri-home-4-fill', label: t('home') },
    { path: '/calendar', icon: 'ri-calendar-fill', label: t('calendar') },
    { path: '/messages', icon: 'ri-message-3-fill', label: t('messages') },
    { path: '/gallery', icon: 'ri-gallery-fill', label: t('gallery') },
    { path: '/profile', icon: 'ri-user-fill', label: t('profile') }
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 px-0 py-2 z-50">
      <div className="grid grid-cols-5 gap-0">
        {navItems.map((item) => (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            className={`flex flex-col items-center justify-center py-2 px-1 transition-colors ${
              location.pathname === item.path
                ? 'text-[#5B9BD5]'
                : 'text-gray-500'
            }`}
          >
            <div className="w-5 h-5 flex items-center justify-center mb-1">
              <i className={`${item.icon} text-lg`}></i>
            </div>
            <span className="text-xs font-medium">{item.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
